
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("g7X8y", function(module, exports) {

$parcel$export(module.exports, "default", () => $377d1a2d96ea3eb0$export$2e2bcd8739ae039);

var $2c2c0 = parcelRequire("2c2c0");
function $377d1a2d96ea3eb0$export$2e2bcd8739ae039({ startRadian: startRadian, endRadian: endRadian }, cClockwise, even = true) {
    let _angle = startRadian - endRadian;
    if (!cClockwise) _angle = endRadian - startRadian;
    let degree = Math.floor((0, $2c2c0.default)(_angle));
    degree = degree < 0 ? degree + 360 : degree;
    even && (degree = degree % 2 == 1 ? degree + 1 : degree);
    return degree;
}

});
parcelRegister("2c2c0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0253ba8048e12397$export$2e2bcd8739ae039);
function $0253ba8048e12397$export$2e2bcd8739ae039(radian) {
    return radian * (180 / Math.PI);
}

});


parcelRegister("27dcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $444a4eb717408c73$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $444a4eb717408c73$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(point, cb){
        super();
        new (0, $lyHkj.default).Tween(point).to({
            scale: 1
        }, 300).easing((0, $lyHkj.default).Easing.Elastic.Out).onComplete(()=>cb()).start();
    }
}

});

parcelRegister("6MHFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a656fd25c1d4e05b$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $a656fd25c1d4e05b$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(onUpdate, rotationCount, onComplete){
        super();
        const a = {
            radian: 0
        };
        const targetRadian = rotationCount * (Math.PI * 2);
        new (0, $lyHkj.default).Tween({
            ...a
        }).to({
            radian: targetRadian
        }, 3000).delay(600).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate((a)=>onUpdate(a.radian)).onComplete(()=>onComplete()).start();
    }
}

});

parcelRegister("2qYgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $39dba461b9d2aedd$export$2e2bcd8739ae039);
function $39dba461b9d2aedd$export$2e2bcd8739ae039(cCoord, cCircumPoint, aSide1, aSide2) {
    let angle = Math.atan2(cCircumPoint.y - cCoord.y, cCircumPoint.x - cCoord.x);
    if (angle < 0) angle += 2 * Math.PI;
    let start = aSide1;
    let end = aSide2;
    if (start < 0) start += 2 * Math.PI;
    if (end < 0) end += 2 * Math.PI;
    if (start <= end) return angle >= start && angle <= end;
    else return angle >= start || angle <= end;
}

});

parcelRegister("htSjE", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $e6d9114a2720969b$export$84c26df82650dc9b);

var $dcKRv = parcelRequire("dcKRv");

var $7Ix7i = parcelRequire("7Ix7i");
"use strict";
const $e6d9114a2720969b$var$cachedGroups = {};
function $e6d9114a2720969b$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $e6d9114a2720969b$var$cachedGroups[uid] || $e6d9114a2720969b$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $e6d9114a2720969b$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $7Ix7i.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $dcKRv.BindGroup)(bindGroupResources);
    $e6d9114a2720969b$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("e9jtq", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $31a4fb027e026d19$export$e56d0a06781accc9);

var $aY7HM = parcelRequire("aY7HM");

var $hVXXe = parcelRequire("hVXXe");
"use strict";
class $31a4fb027e026d19$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $aY7HM.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $hVXXe.nextPow2)(minWidth);
        minHeight = (0, $hVXXe.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $31a4fb027e026d19$export$e56d0a06781accc9 = new $31a4fb027e026d19$export$62d9f0b8aada09d7();

});

parcelRegister("bRPvq", function(module, exports) {

$parcel$export(module.exports, "AbstractRenderer", () => $7c1ba3270bd37f6d$export$58ab3ed211eed562);

var $36Ltv = parcelRequire("36Ltv");

var $gHh6O = parcelRequire("gHh6O");

var $d7k7b = parcelRequire("d7k7b");

var $2RIEa = parcelRequire("2RIEa");

var $fdcJR = parcelRequire("fdcJR");

var $1Ki8H = parcelRequire("1Ki8H");


var $9W01S = parcelRequire("9W01S");

var $anqU0 = parcelRequire("anqU0");

var $98bME = parcelRequire("98bME");
"use strict";
const $7c1ba3270bd37f6d$var$defaultRunners = [
    "init",
    "destroy",
    "contextChange",
    "resolutionChange",
    "resetState",
    "renderEnd",
    "renderStart",
    "render",
    "update",
    "postrender",
    "prerender"
];
const $7c1ba3270bd37f6d$var$_AbstractRenderer = class _AbstractRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($98bME))) {
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ constructor(config){
        super();
        /** @internal */ this.uid = (0, $fdcJR.uid)("renderer");
        /** @internal */ this.runners = /* @__PURE__ */ Object.create(null);
        /** @internal */ this.renderPipes = /* @__PURE__ */ Object.create(null);
        this._initOptions = {};
        this._systemsHash = /* @__PURE__ */ Object.create(null);
        this.type = config.type;
        this.name = config.name;
        this.config = config;
        const combinedRunners = [
            ...$7c1ba3270bd37f6d$var$defaultRunners,
            ...this.config.runners ?? []
        ];
        this._addRunners(...combinedRunners);
        this._unsafeEvalCheck();
    }
    /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */ async init(options = {}) {
        const skip = options.skipExtensionImports === true ? true : options.manageImports === false;
        await (0, $gHh6O.loadEnvironmentExtensions)(skip);
        this._addSystems(this.config.systems);
        this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
        for(const systemName in this._systemsHash){
            const system = this._systemsHash[systemName];
            const defaultSystemOptions = system.constructor.defaultOptions;
            options = {
                ...defaultSystemOptions,
                ...options
            };
        }
        options = {
            ..._AbstractRenderer.defaultOptions,
            ...options
        };
        this._roundPixels = options.roundPixels ? 1 : 0;
        for(let i = 0; i < this.runners.init.items.length; i++)await this.runners.init.items[i].init(options);
        this._initOptions = options;
    }
    render(args, deprecated) {
        let options = args;
        if (options instanceof (0, $d7k7b.Container)) {
            options = {
                container: options
            };
            if (deprecated) {
                (0, $1Ki8H.deprecation)((0, $1Ki8H.v8_0_0), "passing a second argument is deprecated, please use render options instead");
                options.target = deprecated.renderTexture;
            }
        }
        options.target || (options.target = this.view.renderTarget);
        if (options.target === this.view.renderTarget) {
            this._lastObjectRendered = options.container;
            options.clearColor ?? (options.clearColor = this.background.colorRgba);
            options.clear ?? (options.clear = this.background.clearBeforeRender);
        }
        if (options.clearColor) {
            const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
            options.clearColor = isRGBAArray ? options.clearColor : (0, $36Ltv.Color).shared.setValue(options.clearColor).toArray();
        }
        if (!options.transform) {
            options.container.updateLocalTransform();
            options.transform = options.container.localTransform;
        }
        options.container.enableRenderGroup();
        this.runners.prerender.emit(options);
        this.runners.renderStart.emit(options);
        this.runners.render.emit(options);
        this.runners.renderEnd.emit(options);
        this.runners.postrender.emit(options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        const previousResolution = this.view.resolution;
        this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution);
        if (resolution !== void 0 && resolution !== previousResolution) this.runners.resolutionChange.emit(resolution);
    }
    /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */ clear(options = {}) {
        const renderer = this;
        options.target || (options.target = renderer.renderTarget.renderTarget);
        options.clearColor || (options.clearColor = this.background.colorRgba);
        options.clear ?? (options.clear = (0, $9W01S.CLEAR).ALL);
        const { clear: clear, clearColor: clearColor, target: target } = options;
        (0, $36Ltv.Color).shared.setValue(clearColor ?? this.background.colorRgba);
        renderer.renderTarget.clear(target, clear, (0, $36Ltv.Color).shared.toArray());
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.view.resolution;
    }
    set resolution(value) {
        this.view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */ get width() {
        return this.view.texture.frame.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this.view.texture.frame.height;
    }
    // NOTE: this was `view` in v7
    /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */ get canvas() {
        return this.view.canvas;
    }
    /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */ get lastObjectRendered() {
        return this._lastObjectRendered;
    }
    /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */ get renderingToScreen() {
        const renderer = this;
        return renderer.renderTarget.renderingToScreen;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */ get screen() {
        return this.view.screen;
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ _addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $anqU0.SystemRunner)(runnerId);
        });
    }
    _addSystems(systems) {
        let i;
        for(i in systems){
            const val = systems[i];
            this._addSystem(val.value, val.name);
        }
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ _addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    _addPipes(pipes, pipeAdaptors) {
        const adaptors = pipeAdaptors.reduce((acc, adaptor)=>{
            acc[adaptor.name] = adaptor.value;
            return acc;
        }, {});
        pipes.forEach((pipe)=>{
            const PipeClass = pipe.value;
            const name = pipe.name;
            const Adaptor = adaptors[name];
            this.renderPipes[name] = new PipeClass(this, Adaptor ? new Adaptor() : null);
        });
    }
    destroy(options = false) {
        this.runners.destroy.items.reverse();
        this.runners.destroy.emit(options);
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = null;
        this.renderPipes = null;
    }
    /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */ generateTexture(options) {
        return this.textureGenerator.generateTexture(options);
    }
    /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */ _unsafeEvalCheck() {
        if (!(0, $2RIEa.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
    /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */ resetState() {
        this.runners.resetState.emit();
    }
};
/** The default options for the renderer. */ $7c1ba3270bd37f6d$var$_AbstractRenderer.defaultOptions = {
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */ resolution: 1,
    /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */ failIfMajorPerformanceCaveat: false,
    /**
   * Should round pixels be forced when rendering?
   * @default false
   */ roundPixels: false
};
let $7c1ba3270bd37f6d$export$58ab3ed211eed562 = $7c1ba3270bd37f6d$var$_AbstractRenderer;

});
parcelRegister("gHh6O", function(module, exports) {

$parcel$export(module.exports, "loadEnvironmentExtensions", () => $73b7dba69a4e9a90$export$3b30260a318c769f);

var $cMikx = parcelRequire("cMikx");
"use strict";
const $73b7dba69a4e9a90$var$environments = [];
(0, $cMikx.extensions).handleByNamedList((0, $cMikx.ExtensionType).Environment, $73b7dba69a4e9a90$var$environments);
async function $73b7dba69a4e9a90$export$3b30260a318c769f(skip) {
    if (skip) return;
    for(let i = 0; i < $73b7dba69a4e9a90$var$environments.length; i++){
        const env = $73b7dba69a4e9a90$var$environments[i];
        if (env.value.test()) {
            await env.value.load();
            return;
        }
    }
}
async function $73b7dba69a4e9a90$export$72225172dd907279(add) {
    return $73b7dba69a4e9a90$export$3b30260a318c769f(!add);
}

});

parcelRegister("2RIEa", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $7aebd45fef6bbf9b$export$70c0711f29adc5cf);
"use strict";
let $7aebd45fef6bbf9b$var$unsafeEval;
function $7aebd45fef6bbf9b$export$70c0711f29adc5cf() {
    if (typeof $7aebd45fef6bbf9b$var$unsafeEval === "boolean") return $7aebd45fef6bbf9b$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $7aebd45fef6bbf9b$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (_e) {
        $7aebd45fef6bbf9b$var$unsafeEval = false;
    }
    return $7aebd45fef6bbf9b$var$unsafeEval;
}

});

parcelRegister("9W01S", function(module, exports) {

$parcel$export(module.exports, "CLEAR", () => $019d7ae2ae677ac1$export$6c4d37c7f376a1de);
"use strict";
var $019d7ae2ae677ac1$export$6c4d37c7f376a1de = /* @__PURE__ */ ((CLEAR2)=>{
    CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
    CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
    CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
    CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
    CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
    CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
    CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
    CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
    return CLEAR2;
})($019d7ae2ae677ac1$export$6c4d37c7f376a1de || {});

});

parcelRegister("anqU0", function(module, exports) {

$parcel$export(module.exports, "SystemRunner", () => $27d711bf58994fc3$export$ff5f2fe687fe3979);
"use strict";
class $27d711bf58994fc3$export$ff5f2fe687fe3979 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [];
        this._name = name;
    }
    /* jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /* jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        const { name: name, items: items } = this;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return this;
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        if (item[this._name]) {
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) this.items.splice(index, 1);
        return this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.indexOf(item) !== -1;
    }
    /** Remove all listeners from the Runner */ removeAll() {
        this.items.length = 0;
        return this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}

});


parcelRegister("AFJYy", function(module, exports) {

$parcel$export(module.exports, "ApplicationInitHook", () => $00c29f6d2290dcd3$export$918f3e4d2b801859);
$parcel$export(module.exports, "RendererInitHook", () => $00c29f6d2290dcd3$export$5fba6e443d2fb64);

var $cMikx = parcelRequire("cMikx");

var $a02t4 = parcelRequire("a02t4");
"use strict";
class $00c29f6d2290dcd3$export$918f3e4d2b801859 {
    static init() {
        globalThis.__PIXI_APP_INIT__?.(this, (0, $a02t4.VERSION));
    }
    static destroy() {}
}
/** @ignore */ $00c29f6d2290dcd3$export$918f3e4d2b801859.extension = (0, $cMikx.ExtensionType).Application;
class $00c29f6d2290dcd3$export$5fba6e443d2fb64 {
    constructor(renderer){
        this._renderer = renderer;
    }
    init() {
        globalThis.__PIXI_RENDERER_INIT__?.(this._renderer, (0, $a02t4.VERSION));
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $00c29f6d2290dcd3$export$5fba6e443d2fb64.extension = {
    type: [
        (0, $cMikx.ExtensionType).WebGLSystem,
        (0, $cMikx.ExtensionType).WebGPUSystem
    ],
    name: "initHook",
    priority: -10
};

});
parcelRegister("a02t4", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $840423e2c9afffc1$export$a4ad2735b021c132);

var $98bME = parcelRequire("98bME");
"use strict";
const $840423e2c9afffc1$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
const $840423e2c9afffc1$export$a4ad2735b021c132 = "8.10.1";

});



var $d55ji = parcelRequire("d55ji");

var $d55ji = parcelRequire("d55ji");

var $2wguv = parcelRequire("2wguv");

var $99f70 = parcelRequire("99f70");

var $8O5yO = parcelRequire("8O5yO");
const $681816684a7b70ff$export$64436d1175f556d9 = {
    circum: "x",
    center: "2x"
};
const $681816684a7b70ff$export$ca8f2c484d507a5d = 200;
const $681816684a7b70ff$export$525b32b135428804 = 140;
const $681816684a7b70ff$export$3cf98fad6d5d4142 = 40;
const $681816684a7b70ff$export$2f65378ba556425d = 270;
const $681816684a7b70ff$export$fd1bf64c4a4ea04a = [
    (0, $8O5yO.default)(40),
    (0, $8O5yO.default)(140),
    (0, $8O5yO.default)(270)
];
const $681816684a7b70ff$export$c7609d9da8d80867 = {
    x: 500,
    y: 360
};
const $681816684a7b70ff$export$df1c1fbcdd7e8a48 = {
    x: 300,
    y: 600
};
const $681816684a7b70ff$export$158208f930a33a87 = {
    x: 100,
    y: 20
};
const $681816684a7b70ff$export$186dbbe504e85fe1 = [
    {
        x: 90,
        y: 800
    },
    {
        x: 450,
        y: 800
    },
    {
        x: 810,
        y: 800
    }
];
const $681816684a7b70ff$export$75f2cc8245aafe09 = [
    {
        x: -340,
        y: 480
    },
    {
        x: 120,
        y: 480
    },
    {
        x: -110,
        y: 660
    }
];
const $681816684a7b70ff$export$840ec2322406bfdd = {
    x: 1130,
    y: 200
};
const $681816684a7b70ff$export$190b4c043fb6edf4 = {
    x: 1500,
    y: 800
};
const $681816684a7b70ff$export$bdea539c223eec51 = [
    0xFFBD06,
    0x000000,
    0x000000
];
const $681816684a7b70ff$export$4697ad01a4a84996 = [
    "/circle-theorem-1/info-slider/1.jpeg",
    "/circle-theorem-1/info-slider/2.jpeg",
    "/circle-theorem-1/info-slider/3.jpeg",
    "/circle-theorem-1/info-slider/4.jpeg",
    "/circle-theorem-1/info-slider/5.jpeg",
    "/circle-theorem-1/info-slider/6.jpeg",
    "/circle-theorem-1/info-slider/7.jpeg",
    "/circle-theorem-1/info-slider/8.jpeg",
    "/circle-theorem-1/info-slider/9.jpeg",
    "/circle-theorem-1/info-slider/10.jpeg",
    "/circle-theorem-1/info-slider/11.jpeg",
    "/circle-theorem-1/info-slider/12.jpeg",
    "/circle-theorem-1/info-slider/13.jpeg",
    "/circle-theorem-1/info-slider/14.jpeg"
];
const $681816684a7b70ff$export$b6c787c9f0e7e936 = [
    {
        text: "2",
        x: 75,
        y: 0,
        color: 0x000000
    },
    {
        text: "x",
        x: 109,
        y: 0,
        color: 0x000000,
        fontSize: 40
    },
    {
        text: "x\xb0",
        x: 150,
        y: 0,
        color: (0, $99f70.CIRCUM_ANGLE_COLOR).textColor,
        fontWeight: "600"
    },
    {
        text: "=",
        x: 259,
        y: 0,
        color: 0x000000
    },
    {
        text: "2x\xb0",
        x: 300,
        y: 0,
        color: (0, $99f70.CENTER_ANGLE_COLOR).textColor,
        fontWeight: "600"
    }
];



var $83ZZo = parcelRequire("83ZZo");
var $62bc9e15f9b76e98$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["setCalcLine"] = "SET_CALC_LINE";
    EnumEventBus["showCalcLine"] = "SHOW_CALCULATION_LINE";
    EnumEventBus["drawElements"] = "DRAW_ELEMENTS";
    EnumEventBus["setCalcForAnim"] = "SET_CALCULATION_LINE_FOR_ANIMATION";
    EnumEventBus["showSliders"] = "SHOW_SLIDERS";
    EnumEventBus["setCircumPoint"] = "SET_CIRCUMFERENCE_POINT";
    EnumEventBus["setCentralAngle"] = "SET_CENTRAL_ANGLE";
    EnumEventBus["setRotateCircle"] = "SET_ROTATE_CIRCLE";
    return EnumEventBus;
}({});
const $62bc9e15f9b76e98$export$5087227eb54526 = new (0, $83ZZo.EventEmitter)();


class $06bd070c6a9ef8fb$export$2e2bcd8739ae039 extends (0, $2wguv.default) {
    constructor(cCoord){
        super(cCoord, (0, $681816684a7b70ff$export$ca8f2c484d507a5d), (0, $681816684a7b70ff$export$fd1bf64c4a4ea04a)), this.EventBus = (0, $62bc9e15f9b76e98$export$5087227eb54526);
        this.EventBus.on((0, $62bc9e15f9b76e98$export$cb883390c27ec6dd).setRotateCircle, (v)=>this.moveAllPoints(v));
        this.EventBus.on((0, $62bc9e15f9b76e98$export$cb883390c27ec6dd).setCentralAngle, (v)=>this.moveCentralAngle(v));
        this.EventBus.on((0, $62bc9e15f9b76e98$export$cb883390c27ec6dd).setCircumPoint, (v)=>this.moveCircumPoint(v));
    }
    moveAllPoints(v) {
        const points = this.getRedPoints();
        const pointInfoArr = this.getRefRadians().map((ref, refI)=>({
                pTag: points[refI].tag,
                radian: ref + v / 100 * (Math.PI / 3)
            }));
        this.setRadian(pointInfoArr, true);
    }
    moveCentralAngle(v) {
        const refPoints = this.getRefRadians();
        const points = this.getRedPoints();
        const pointInfoArr = [
            points[0],
            points[1]
        ].map((p, pI)=>{
            const radian = refPoints[pI] + (pI == 0 ? 1 : -1) * v / 100 * (Math.PI / 8);
            return {
                pTag: p.tag,
                radian: radian
            };
        });
        this.setRadian(pointInfoArr, true);
    }
    moveCircumPoint(v) {
        const circumPoint = this.getRedPoints()[2];
        const cirumRefRadian = this.getRefRadians()[2];
        this.setRadian([
            {
                pTag: circumPoint.tag,
                radian: cirumRefRadian + v / 100 * Math.PI / 6
            }
        ], true);
    }
}



var $etsqE = parcelRequire("etsqE");
class $10a32387cb48efd6$export$2e2bcd8739ae039 {
    // r1 - circum - l1
    // r1 - side1 - l2
    // r2 - side2 - l1
    // r2 - center - l2
    constructor(){
        this.rLine1CirSide1 = new (0, $etsqE.default)();
        this.rLine2CenSide2 = new (0, $etsqE.default)();
        this.lLine1CirSide2 = new (0, $etsqE.default)();
        this.lLine2CenSide1 = new (0, $etsqE.default)();
    }
    draw([center, side1, side2, circum]) {
        this.rLine1CirSide1.draw(circum, side1);
        this.rLine2CenSide2.draw(center, side2);
        this.lLine1CirSide2.draw(circum, side2);
        this.lLine2CenSide1.draw(center, side1);
    }
}




var $9NMk5 = parcelRequire("9NMk5");

var $99f70 = parcelRequire("99f70");

var $elBkP = parcelRequire("elBkP");

var $5ekDK = parcelRequire("5ekDK");

var $g7X8y = parcelRequire("g7X8y");
class $720c462c68a18c77$export$2e2bcd8739ae039 {
    constructor(){
        this.centerAngle = new (0, $9NMk5.default)("center", (0, $99f70.CENTER_ANGLE_COLOR));
        this.circumAngle = new (0, $9NMk5.default)("circum", (0, $99f70.CIRCUM_ANGLE_COLOR));
        this.cloneCircumAngles = [
            new (0, $9NMk5.default)("circum2", (0, $99f70.CIRCUM_ANGLE_COLOR)),
            new (0, $9NMk5.default)("circum3", (0, $99f70.CIRCUM_ANGLE_COLOR))
        ];
        this.emitAngles = (degree)=>(0, $62bc9e15f9b76e98$export$5087227eb54526).emit((0, $62bc9e15f9b76e98$export$cb883390c27ec6dd).setCalcLine, degree);
    }
    setVisible(status) {
        this.centerAngle.setVisible(status);
        this.circumAngle.setVisible(status);
    }
    drawCenterAngle(cPoint, s1Point, s2Point, clockwise) {
        const { startRadian: startRadian, endRadian: endRadian } = (0, $5ekDK.default)(cPoint, s1Point, s2Point);
        const degree = (0, $g7X8y.default)({
            startRadian: startRadian,
            endRadian: endRadian
        }, clockwise);
        this.centerAngle.draw(cPoint, startRadian, endRadian, degree, clockwise);
        this.centerAngle.x = cPoint.x;
        this.centerAngle.y = cPoint.y;
        return degree;
    }
    drawCircumAngle(circumPoint, s1Point, s2Point, degree, clockwise) {
        const angles = (0, $5ekDK.default)(circumPoint, s1Point, s2Point);
        const smallDistance = Math.min((0, $elBkP.default)(circumPoint, s1Point), (0, $elBkP.default)(circumPoint, s2Point));
        this.circumAngle.smallDistance = smallDistance;
        this.circumAngle.draw(circumPoint, angles.startRadian, angles.endRadian, degree / 2, clockwise);
        this.circumAngle.x = circumPoint.x;
        this.circumAngle.y = circumPoint.y;
    }
    draw([cPoint, s1Point, s2Point, circumPoint], clockwise) {
        const centerDegree = this.drawCenterAngle(cPoint, s1Point, s2Point, clockwise);
        this.drawCircumAngle(circumPoint, s1Point, s2Point, centerDegree, clockwise);
        this.emitAngles(centerDegree);
    }
}



var $83ZZo = parcelRequire("83ZZo");

var $9e8jK = parcelRequire("9e8jK");

var $2Msgp = parcelRequire("2Msgp");

class $40325d75c0c50c14$export$2e2bcd8739ae039 extends $83ZZo.Graphics {
    constructor(cCoord, startPoint, radian, color){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.addToLayer = ()=>this.Layers.Bottom.addChild(this);
        this.cCoord = cCoord;
        this.startPoint = startPoint;
        this.startRadian = radian;
        this.endRadian = radian;
        this.fillColor = color;
        this.addToLayer();
    }
    draw(startRadian, endRadian, startPoint) {
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        startPoint && (this.startPoint = startPoint);
        this.drawBg();
    }
    drawBg() {
        const [s1Point, s2Point] = (0, $2Msgp.default)(this.cCoord, [
            this.startRadian,
            this.endRadian
        ], (0, $681816684a7b70ff$export$ca8f2c484d507a5d));
        this.clear().moveTo(this.startPoint.x, this.startPoint.y).lineTo(s1Point.x, s1Point.y).arc(this.cCoord.x, this.cCoord.y, (0, $681816684a7b70ff$export$ca8f2c484d507a5d), this.startRadian, this.endRadian, true).lineTo(s2Point.x, s2Point.y).fill({
            color: this.fillColor,
            alpha: .7
        });
    }
}



class $7f89836f68fba19c$export$2e2bcd8739ae039 {
    constructor(cCoord, radian){
        this.PointManager = (0, $06bd070c6a9ef8fb$export$2e2bcd8739ae039).getInstance();
        this.cCoord = cCoord;
        const circlePoint = this.PointManager.circlePoint;
        const circumPoint = this.PointManager.getRedPoints()[2];
        this.circumBg = new (0, $40325d75c0c50c14$export$2e2bcd8739ae039)(this.cCoord, circumPoint, radian, 0x98d6ff);
        this.centerBg = new (0, $40325d75c0c50c14$export$2e2bcd8739ae039)(this.cCoord, circlePoint, radian, 0xffceeb);
    }
}



var $2hUu0 = parcelRequire("2hUu0");

var $8O5yO = parcelRequire("8O5yO");

var $5ekDK = parcelRequire("5ekDK");

var $g7X8y = parcelRequire("g7X8y");
class $7640f047739c8112$export$2e2bcd8739ae039 {
    constructor(){
        this.center = new (0, $2hUu0.default)("O");
        this.side1 = new (0, $2hUu0.default)("A");
        this.side2 = new (0, $2hUu0.default)("B");
        this.circum = new (0, $2hUu0.default)("C");
        this.setVisible = (visible)=>[
                this.center,
                this.side1,
                this.side2,
                this.circum
            ].forEach((pName)=>pName.visible = visible);
    }
    updateCenterName([cPoint, s1Point, s2Point], cClockwise) {
        const cAngles = (0, $5ekDK.default)(cPoint, s1Point, s2Point);
        const degree = (0, $g7X8y.default)(cAngles, cClockwise);
        const initialAngle = cClockwise ? cAngles.endRadian : cAngles.startRadian;
        const nameAngle = initialAngle + (0, $8O5yO.default)(degree / 2) + Math.PI;
        const coord = {
            x: Math.cos(nameAngle) * 30 + cPoint.x,
            y: Math.sin(nameAngle) * 30 + cPoint.y
        };
        this.center.updateCoord(coord);
    }
    updateCoord(coords) {
        this.side1.updateCoord(coords[0]);
        this.side2.updateCoord(coords[1]);
        this.circum.updateCoord(coords[2]);
    }
}



var $jG160 = parcelRequire("jG160");

var $cbvsj = parcelRequire("cbvsj");


const $dbe2cb72bb58209e$var$SliderGen = [
    {
        head: "circumference angle",
        colors: {
            bgColor: 0x21D4FE,
            barColor: 0x000000,
            buttonColor: 0x21D4FE
        },
        onUpdate: (v)=>(0, $62bc9e15f9b76e98$export$5087227eb54526).emit((0, $62bc9e15f9b76e98$export$cb883390c27ec6dd).setCircumPoint, v - 100)
    },
    {
        head: "central angle",
        colors: {
            bgColor: 0xFC99C4,
            barColor: 0x000000,
            buttonColor: 0xFC99C4
        },
        onUpdate: (v)=>(0, $62bc9e15f9b76e98$export$5087227eb54526).emit((0, $62bc9e15f9b76e98$export$cb883390c27ec6dd).setCentralAngle, v - 100)
    },
    {
        head: "rotate the circle",
        colors: {
            bgColor: 0xBFBFBF,
            barColor: 0x000000,
            buttonColor: 0x000000
        },
        onUpdate: (v)=>(0, $62bc9e15f9b76e98$export$5087227eb54526).emit((0, $62bc9e15f9b76e98$export$cb883390c27ec6dd).setRotateCircle, v - 100)
    }
];
class $dbe2cb72bb58209e$export$2e2bcd8739ae039 extends (0, $cbvsj.default) {
    constructor(){
        super($dbe2cb72bb58209e$var$SliderGen, (0, $681816684a7b70ff$export$186dbbe504e85fe1), (0, $681816684a7b70ff$export$75f2cc8245aafe09));
    }
}



var $aZDOo = parcelRequire("aZDOo");

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $e7429cb1537602d1$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(AngleBg, radian, cCoord, onComp){
        super();
        this.AngleBg = AngleBg;
        this.cCoord = cCoord;
        new (0, $lyHkj.default).Tween({
            ...AngleBg
        }).to({
            startRadian: radian
        }, 2000).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate((ABg)=>{
            this.AngleBg.draw(ABg.startRadian, ABg.endRadian);
        }).onComplete(()=>onComp()).start();
    }
}



var $kOFqu = parcelRequire("kOFqu");

var $a9Ugo = parcelRequire("a9Ugo");

var $27dcx = parcelRequire("27dcx");

var $6MHFV = parcelRequire("6MHFV");

var $hL4lC = parcelRequire("hL4lC");

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $7aed5833e25211ad$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(Element, onComp, delay = 0){
        super();
        new (0, $lyHkj.default).Tween(Element).to({
            alpha: 0
        }, 1500).easing((0, $lyHkj.default).Easing.Linear.None).delay(delay).onComplete(()=>onComp()).start();
    }
}


function $3a564de31e8b7fac$export$5af22673ad419202(point, coord) {
    return new Promise((resolve)=>{
        point.draw(coord);
        point.scale = 0.2;
        new (0, $27dcx.default)(point, ()=>resolve());
    });
}
function $3a564de31e8b7fac$export$2707a00551b9d1cc(angle, value) {
    return new Promise((resolve)=>{
        angle.visible = true;
        angle.scale.set(0.3);
        new (0, $aZDOo.default)(angle, ()=>{
            angle.AngleValue.setValue(value);
            angle.AngleValue.visible = true;
            resolve();
        });
    });
}
function $3a564de31e8b7fac$export$720cbfe21b054bd1(line, from, to) {
    return new Promise((resolve)=>new (0, $a9Ugo.default)(line, from, to, resolve));
}
function $3a564de31e8b7fac$export$7e0882271c304db0(circle, radian, index, transparent, coord) {
    return new Promise((resolve)=>new (0, $kOFqu.default)(circle, radian, index, transparent, coord, resolve));
}
function $3a564de31e8b7fac$export$e0576084f6bcee09(AngleBg, radian, coord) {
    return new Promise((resolve)=>new (0, $e7429cb1537602d1$export$2e2bcd8739ae039)(AngleBg, radian, coord, ()=>resolve()));
}
function $3a564de31e8b7fac$export$d1e2ccf942bf99d6(angleBg) {
    return new Promise((resolve)=>new (0, $7aed5833e25211ad$export$2e2bcd8739ae039)(angleBg, ()=>resolve()));
}
function $3a564de31e8b7fac$export$f584aa9213fc042a(callback) {
    return new Promise((resolve)=>new (0, $6MHFV.default)(callback, resolve));
}
function $3a564de31e8b7fac$export$a50792651bc832af(calcLine) {
    return new Promise(()=>new (0, $hL4lC.default)(calcLine, .3, 1));
}
function $3a564de31e8b7fac$export$543c0984a55507b3(SliderManager) {
    return new Promise(()=>{
        SliderManager.showSliders();
        const sliders = SliderManager.getSliders();
        sliders.forEach((slider)=>new (0, $hL4lC.default)(slider, .3, 1));
    });
}



var $2Msgp = parcelRequire("2Msgp");

var $er2zg = parcelRequire("er2zg");

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $01a5c14fb167077d$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(targetRadians, duration, onUpdate, onComp){
        super();
        const radians = {
            radian1: 0,
            radian2: 0,
            radian3: 0
        };
        new (0, $lyHkj.default).Tween({
            ...radians
        }).to({
            radian1: targetRadians[0],
            radian2: targetRadians[1],
            radian3: targetRadians[2]
        }, duration).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate((r)=>onUpdate([
                r.radian1,
                r.radian2,
                r.radian3
            ])).onComplete(()=>onComp()).start();
    }
}



const $e941fe64cf15f035$var$bRadian = Math.PI / 10;
const $e941fe64cf15f035$var$radiansListArr = [
    [
        [
            -Math.PI / 20 * 1.6,
            -Math.PI / 20 * 1.2,
            -Math.PI / 6
        ],
        [
            Math.PI / 6 * 1.5,
            Math.PI / 6 * 2,
            Math.PI / 1.8
        ],
        [
            Math.PI / 20,
            -Math.PI / 15,
            -Math.PI / 1.7
        ]
    ],
    [
        [
            -Math.PI / 9,
            Math.PI / 9,
            -Math.PI / 6
        ],
        [
            Math.PI / 2.25,
            Math.PI / 4,
            Math.PI / 2
        ],
        [
            Math.PI / 6,
            -Math.PI / 6,
            -Math.PI / 2
        ]
    ]
];
async function $e941fe64cf15f035$export$881542f60896fc9(AngleBgArr, circle, PointManager, AngleManager, LineManager) {
    const radiansList = $e941fe64cf15f035$var$radiansListArr[AngleBgArr.length - 1];
    const refAngles = PointManager.getInitialRadians();
    const handleUpdate = (radians, offsetAngles)=>{
        $e941fe64cf15f035$var$danceElements(AngleBgArr, circle, PointManager, AngleManager, LineManager, refAngles.map((rAngle, rI)=>rAngle + offsetAngles[rI]), radians);
    };
    const calcPrevArray = (index)=>{
        return radiansList.reduce((total, curr, currIndex)=>{
            const t = [
                total[0] + curr[0],
                total[1] + curr[1],
                total[2] + curr[2]
            ];
            return index > currIndex ? t : total;
        }, [
            0,
            0,
            0
        ]);
    };
    const calcDuration = (index)=>Math.floor(Math.abs(radiansList[index][2] / $e941fe64cf15f035$var$bRadian) * 200);
    const lastPosition = calcPrevArray(radiansList.length).map((r)=>-r);
    const lastDuration = Math.floor(Math.abs(lastPosition[2] / $e941fe64cf15f035$var$bRadian) * 400);
    await $e941fe64cf15f035$var$movePoints(radiansList[0], calcDuration(0), (r)=>handleUpdate(r, [
            0,
            0,
            0
        ]));
    await $e941fe64cf15f035$var$movePoints(radiansList[1], calcDuration(1), (r)=>handleUpdate(r, calcPrevArray(1)));
    await $e941fe64cf15f035$var$movePoints(radiansList[2], calcDuration(2), (r)=>handleUpdate(r, calcPrevArray(2)));
    await $e941fe64cf15f035$var$movePoints(lastPosition, lastDuration, (r)=>handleUpdate(r, calcPrevArray(radiansList.length)));
}
const $e941fe64cf15f035$var$movePoints = (tRadians, duration, handleUpdate)=>{
    return new Promise((resolve)=>{
        new (0, $01a5c14fb167077d$export$2e2bcd8739ae039)(tRadians, duration, (r)=>handleUpdate(r, 0), ()=>resolve());
    });
};
function $e941fe64cf15f035$var$danceElements(AngleBgArr, circle, PointManager, AngleManager, LineManager, refAngles, offsetAngles) {
    const getRadian = (index)=>(0, $er2zg.normalizeRadian)(refAngles[index] + offsetAngles[index]);
    const PointRadians = PointManager.getRedPoints().map((rP, rPI)=>getRadian(rPI));
    const centerPoint = PointManager.getPoints()[0];
    const points = (0, $2Msgp.default)(centerPoint, PointRadians, (0, $681816684a7b70ff$export$ca8f2c484d507a5d));
    const startPointArr = [
        points[2],
        centerPoint
    ];
    LineManager.rLine1CirSide1.draw(points[0], points[2]);
    LineManager.lLine1CirSide2.draw(points[1], points[2]);
    if (AngleBgArr.length > 1) {
        LineManager.lLine2CenSide1.draw(centerPoint, points[0]);
        LineManager.rLine2CenSide2.draw(centerPoint, points[1]);
    }
    AngleManager.draw([
        centerPoint,
        ...points
    ], false);
    AngleManager.circumAngle.AngleValue.setValue("x");
    AngleManager.centerAngle.AngleValue.setValue("2x");
    AngleBgArr.forEach((AngleBg, aI)=>AngleBg.draw(PointRadians[1], PointRadians[0], startPointArr[aI]));
    circle.draw({
        radians: PointRadians.sort((a, b)=>a - b),
        radius: circle.radius
    });
}





var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $03a146d420b31a5a$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(Angle, endCoord, startRadian, endRadian, onUpdate, onComp){
        super();
        const values = {
            x: Angle.x,
            y: Angle.y,
            startRadian: Angle.startRadian,
            endRadian: Angle.endRadian
        };
        new (0, $lyHkj.default).Tween({
            ...values
        }).to({
            x: endCoord.x,
            y: endCoord.y,
            startRadian: startRadian,
            endRadian: endRadian
        }, 2000).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate((v)=>{
            onUpdate(Angle, {
                coord: {
                    x: v.x,
                    y: v.y
                },
                startRadian: v.startRadian,
                endRadian: v.endRadian
            });
        }).onComplete(()=>onComp()).start();
    }
}




var $5ekDK = parcelRequire("5ekDK");
async function $c47307c3809b0cc4$export$d8a8509877285b7d(circle, PointManager, AngleManager) {
    const radians = PointManager.getInitialRadians();
    const points = PointManager.getRedPoints();
    const angles = (0, $5ekDK.default)(points[2], points[0], points[1]);
    AngleManager.cloneCircumAngles.forEach((angle)=>{
        $c47307c3809b0cc4$var$drawCloneAngle(angle, {
            coord: points[2],
            startRadian: angles.startRadian,
            endRadian: angles.endRadian
        });
    });
    return new Promise((res)=>{
        new (0, $03a146d420b31a5a$export$2e2bcd8739ae039)(AngleManager.cloneCircumAngles[0], {
            x: circle.x,
            y: circle.y
        }, radians[0], Math.PI / 2, $c47307c3809b0cc4$var$drawCloneAngle, ()=>{
            new (0, $03a146d420b31a5a$export$2e2bcd8739ae039)(AngleManager.cloneCircumAngles[1], {
                x: circle.x,
                y: circle.y
            }, Math.PI / 2, radians[1], $c47307c3809b0cc4$var$drawCloneAngle, ()=>{
                return AngleManager.cloneCircumAngles.forEach((cAngle, cAI)=>{
                    new (0, $7aed5833e25211ad$export$2e2bcd8739ae039)(cAngle, ()=>{
                        if (cAI == 1) return res();
                    }, 1000);
                    new (0, $7aed5833e25211ad$export$2e2bcd8739ae039)(cAngle.AngleValue, ()=>{}, 1000);
                });
            });
        });
    });
}
function $c47307c3809b0cc4$var$drawCloneAngle(angle, Detail) {
    const { coord: coord, startRadian: startRadian, endRadian: endRadian } = Detail;
    angle.draw(coord, startRadian, endRadian, 50, false);
    angle.AngleValue.setValue("x");
    angle.x = coord.x;
    angle.y = coord.y;
}


async function $578501b65614eb32$export$792f2314b3a6e2b5(context, cb) {
    const { circle: circle, LineManager: LineManager, PointManager: PointManager, AngleManager: AngleManager, AngleBgManager: AngleBgManager, SliderManager: SliderManager, calcLine: calcLine } = context;
    AngleManager.setVisible(false);
    SliderManager.setAllVisible(false);
    const [cCoord, cSide1Point, cSide2Point, cCircumPoint] = PointManager.getPoints().map((p)=>({
            x: p.x,
            y: p.y
        }));
    // Circle
    circle.radians = Array(3).fill((0, $681816684a7b70ff$export$fd1bf64c4a4ea04a)[2]);
    await (0, $3a564de31e8b7fac$export$7e0882271c304db0)(circle, (0, $681816684a7b70ff$export$fd1bf64c4a4ea04a)[2] - 2 * Math.PI, 2, true, cCoord);
    (0, $3a564de31e8b7fac$export$720cbfe21b054bd1)(LineManager.lLine1CirSide2, cCircumPoint, cSide2Point);
    await (0, $3a564de31e8b7fac$export$720cbfe21b054bd1)(LineManager.rLine1CirSide1, cCircumPoint, cSide1Point);
    await (0, $3a564de31e8b7fac$export$2707a00551b9d1cc)(AngleManager.circumAngle, (0, $681816684a7b70ff$export$64436d1175f556d9).circum);
    circle.radians = [
        (0, $681816684a7b70ff$export$fd1bf64c4a4ea04a)[0],
        (0, $681816684a7b70ff$export$fd1bf64c4a4ea04a)[0],
        (0, $681816684a7b70ff$export$fd1bf64c4a4ea04a)[2]
    ];
    const finalRadian = (0, $681816684a7b70ff$export$fd1bf64c4a4ea04a)[1];
    await (0, $3a564de31e8b7fac$export$7e0882271c304db0)(circle, finalRadian, 1, false, cCoord);
    await (0, $3a564de31e8b7fac$export$e0576084f6bcee09)(AngleBgManager.circumBg, finalRadian, cCoord);
    // dance
    circle.radians = (0, $681816684a7b70ff$export$fd1bf64c4a4ea04a);
    await (0, $e941fe64cf15f035$export$881542f60896fc9)([
        AngleBgManager.circumBg
    ], circle, PointManager, AngleManager, LineManager);
    await (0, $3a564de31e8b7fac$export$5af22673ad419202)(PointManager.circlePoint, cCoord);
    (0, $3a564de31e8b7fac$export$720cbfe21b054bd1)(LineManager.lLine2CenSide1, cCoord, cSide2Point);
    await (0, $3a564de31e8b7fac$export$720cbfe21b054bd1)(LineManager.rLine2CenSide2, cCoord, cSide1Point);
    await (0, $c47307c3809b0cc4$export$d8a8509877285b7d)(circle, PointManager, AngleManager);
    await (0, $3a564de31e8b7fac$export$2707a00551b9d1cc)(AngleManager.centerAngle, (0, $681816684a7b70ff$export$64436d1175f556d9).center);
    await (0, $3a564de31e8b7fac$export$e0576084f6bcee09)(AngleBgManager.centerBg, finalRadian, cCoord);
    await (0, $e941fe64cf15f035$export$881542f60896fc9)([
        AngleBgManager.circumBg,
        AngleBgManager.centerBg
    ], circle, PointManager, AngleManager, LineManager);
    (0, $3a564de31e8b7fac$export$d1e2ccf942bf99d6)(AngleBgManager.centerBg);
    await (0, $3a564de31e8b7fac$export$d1e2ccf942bf99d6)(AngleBgManager.circumBg);
    // show calcLine
    (0, $62bc9e15f9b76e98$export$5087227eb54526).emit((0, $62bc9e15f9b76e98$export$cb883390c27ec6dd).setCalcForAnim);
    // draw Active Arc
    // Rotate Circle
    //  await rotateCircleAnim((radian) => drawRotationCB(radian, circle, PointManager, LineManager, AngleManager));
    (0, $3a564de31e8b7fac$export$a50792651bc832af)(calcLine);
    cb();
}



var $3JQTS = parcelRequire("3JQTS");

var $er2zg = parcelRequire("er2zg");

function $01b7ab71ddefa3f4$export$fa3e660ea31c7d1b(PointManager, offsetAngle) {
    const refAngles = PointManager.getInitialRadians();
    const getRadian = (index)=>(0, $er2zg.normalizeRadian)(refAngles[index] + offsetAngle);
    const redPointRadians = PointManager.getRedPoints().map((rP, rPI)=>({
            pTag: rP.tag,
            radian: getRadian(rPI)
        }));
    PointManager.setRadian(redPointRadians);
}
function $01b7ab71ddefa3f4$export$34ce145ca2b805f0(radian, circle, PointManager, LineManager, AngleManager) {
    const points = PointManager.getPoints();
    const radians = PointManager.getRadians();
    $01b7ab71ddefa3f4$export$fa3e660ea31c7d1b(PointManager, radian);
    circle.draw({
        radians: radians,
        radius: circle.radius
    });
    LineManager.draw(points);
    AngleManager.draw(points, true);
    AngleManager.centerAngle.AngleValue.setValue((0, $681816684a7b70ff$export$64436d1175f556d9).center);
    AngleManager.circumAngle.AngleValue.setValue((0, $681816684a7b70ff$export$64436d1175f556d9).circum);
}


class $a1e20a61fabb9621$export$2e2bcd8739ae039 {
    constructor(PointManager, AngleManager, AngleBgManager, LineManager, SliderManager, circle, calcLine){
        this.PointManager = PointManager;
        this.AngleManager = AngleManager;
        this.AngleBgManager = AngleBgManager;
        this.LineManager = LineManager;
        this.SliderManager = SliderManager;
        this.circle = circle;
        this.calcLine = calcLine;
        this.RootEventBus = (0, $3JQTS.RootEventBus);
        this.completedIntroAnim = ()=>{
            this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).completedIntroAnim);
        };
        this.runAnimations = ()=>(0, $578501b65614eb32$export$792f2314b3a6e2b5)(this, ()=>this.completedIntroAnim());
        (0, $01b7ab71ddefa3f4$export$fa3e660ea31c7d1b)(this.PointManager, 0);
        this.AngleManager.draw(PointManager.getPoints(), false);
        this.calcLine.visible = false;
    }
}



var $dF6vz = parcelRequire("dF6vz");

var $83ZZo = parcelRequire("83ZZo");

var $9e8jK = parcelRequire("9e8jK");


var $3JQTS = parcelRequire("3JQTS");

class $6f8cf8cbf12c53fa$export$2e2bcd8739ae039 extends $83ZZo.Container {
    constructor(coord){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.RootEventBus = (0, $3JQTS.RootEventBus), this.EventBus = (0, $62bc9e15f9b76e98$export$5087227eb54526), this.animationEnabled = true;
        Object.assign(this, coord);
        this.addText();
        this.addToLayer();
        this.EventBus.on((0, $62bc9e15f9b76e98$export$cb883390c27ec6dd).setCalcLine, (degree)=>this.updateDegrees([
                Number(degree),
                Number(degree) / 2
            ]));
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).completedIntroAnim, ()=>this.animationEnabled = false);
    }
    generateText(text) {
        const T = new $83ZZo.Text();
        T.text = text.text;
        T.x = text.x;
        T.y = text.y;
        T.style.fill = text.color;
        T.style.fontSize = text.fontSize ? text.fontSize : 50;
        T.style.fontWeight = text.fontWeight ? text.fontWeight : "500";
        this.addChild(T);
    }
    addText() {
        const texts = (0, $681816684a7b70ff$export$b6c787c9f0e7e936);
        texts.forEach((text)=>this.generateText(text));
    }
    updateDegrees(degrees) {
        if (this.animationEnabled) return;
        this.children[2].text = `${degrees[1]}\xb0`;
        this.children[4].text = `${degrees[0]}\xb0`;
    }
    addToLayer() {
        this.Layers.Info.addChild(this);
    }
}



var $6DjBJ = parcelRequire("6DjBJ");


var $2qYgo = parcelRequire("2qYgo");


var $3JQTS = parcelRequire("3JQTS");

var $2Msgp = parcelRequire("2Msgp");
function $fde165ab7d14d4c3$export$8bcf5a95f698e8c4(radians, isbtw) {
    const r = [
        ...radians
    ];
    return isbtw ? [
        r[1],
        r[0],
        r[2]
    ] : r;
}


class $8d71bfeaf5348a18$export$2e2bcd8739ae039 {
    constructor(){
        this.Game = (0, $d55ji.default).getInstance();
        this.RootEventBus = (0, $3JQTS.RootEventBus);
        this.EventBus = (0, $62bc9e15f9b76e98$export$5087227eb54526);
        this.cRadius = (0, $681816684a7b70ff$export$ca8f2c484d507a5d);
        this.calcLineCoord = (0, $681816684a7b70ff$export$df1c1fbcdd7e8a48);
        this.cCoord = this.isPortail();
        this.PointManager = new (0, $06bd070c6a9ef8fb$export$2e2bcd8739ae039)(this.cCoord);
        this.AngleBgManager = new (0, $7f89836f68fba19c$export$2e2bcd8739ae039)(this.cCoord, this.PointManager.getRadians()[0]);
        this.LineManager = new (0, $10a32387cb48efd6$export$2e2bcd8739ae039)();
        this.AngleManager = new (0, $720c462c68a18c77$export$2e2bcd8739ae039)();
        this.PointTagManager = new (0, $7640f047739c8112$export$2e2bcd8739ae039)();
        this.SliderManager = new (0, $dbe2cb72bb58209e$export$2e2bcd8739ae039)();
        this.infoSlider = new (0, $dF6vz.default)((0, $681816684a7b70ff$export$840ec2322406bfdd), (0, $681816684a7b70ff$export$4697ad01a4a84996));
        this.calcLine = new (0, $6f8cf8cbf12c53fa$export$2e2bcd8739ae039)(this.calcLineCoord);
        this.setPointTagManagerVis = (vis)=>this.PointTagManager.setVisible(vis);
        this.runIntroAnimation = ()=>this.IntroAnimationManager.runAnimations();
        this.generatePointTagPoints = ()=>(0, $2Msgp.default)(this.cCoord, this.PointManager.getRadians(), this.cRadius + 34);
        if (!$8d71bfeaf5348a18$export$2e2bcd8739ae039.instance) $8d71bfeaf5348a18$export$2e2bcd8739ae039.instance = this;
        this.isPortail();
        const radians = this.PointManager.getRadians();
        this.circle = new (0, $jG160.default)(this.cCoord, radians, (0, $681816684a7b70ff$export$bdea539c223eec51));
        this.setPointTagManagerVis(false);
        this.IntroAnimationManager = new (0, $a1e20a61fabb9621$export$2e2bcd8739ae039)(this.PointManager, this.AngleManager, this.AngleBgManager, this.LineManager, this.SliderManager, this.circle, this.calcLine);
        new (0, $6DjBJ.default)({
            x: 100,
            y: 10
        });
        this.runIntroAnimation();
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).completedIntroAnim, ()=>{
            this.setPointTagManagerVis(true);
            this.drawElements();
        });
        this.EventBus.on((0, $62bc9e15f9b76e98$export$cb883390c27ec6dd).drawElements, ()=>this.drawElements());
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).drawElements, ()=>this.drawElements());
    }
    static{
        this.getInstance = ()=>$8d71bfeaf5348a18$export$2e2bcd8739ae039.instance;
    }
    isPortail() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) return 0, $681816684a7b70ff$export$c7609d9da8d80867;
        this.calcLineCoord = {
            x: dim.WIDTH / 2 - 200,
            y: dim.HEIGHT / 2 + 250
        };
        return {
            x: dim.WIDTH / 2,
            y: dim.HEIGHT / 2
        };
    }
    drawElements() {
        const points = this.PointManager.getRedPoints();
        const radians = this.PointManager.getRadians();
        const isbtw = (0, $2qYgo.default)(this.cCoord, points[2], radians[0], radians[1]);
        this.PointManager.draw();
        this.circle.draw({
            radians: (0, $fde165ab7d14d4c3$export$8bcf5a95f698e8c4)(radians, isbtw),
            radius: this.cRadius
        });
        this.LineManager.draw(this.PointManager.getPoints());
        this.AngleManager.draw(this.PointManager.getPoints(), isbtw);
        this.PointTagManager.updateCenterName(this.PointManager.getPoints(), isbtw);
        this.PointTagManager.updateCoord(this.generatePointTagPoints());
    }
}



const $0b59f4c193b7af87$var$canvas = document.querySelector("#canvas");
if ($0b59f4c193b7af87$var$canvas) window.context = new (0, $d55ji.default)($0b59f4c193b7af87$var$canvas, (0, $681816684a7b70ff$export$4697ad01a4a84996), ()=>new (0, $8d71bfeaf5348a18$export$2e2bcd8739ae039)());
else console.error("Canvas is not found");


//# sourceMappingURL=index.76a3df12.js.map
